import { render } from "./SwitchControl.vue?vue&type=template&id=16023e5f"
import script from "./SwitchControl.vue?vue&type=script&lang=js"
export * from "./SwitchControl.vue?vue&type=script&lang=js"
script.render = render

export default script